//replacement for  "controls/tumbler_switch.js"

import TemplateView from '../TemplateView'
import {atImgPath} from '../atBrowserUtils'

const ImagePathes = {
    "big": {
        on: "switcher_fg_on.png",
        off: "switcher_fg_off.png",
    },
    "small": {
        on: "switcher_small_fg_on.png",
        off: "switcher_small_fg_off.png",
    }
}

export default class TumblerSwitch extends TemplateView
{
    constructor({
        additionalClass,
        onSwitchCallback
    }) {
        super()
        this.additionalClass = additionalClass;
        this.onSwitchCallback = onSwitchCallback;

        this.state = {
            enabled: false,     //todo: I use same property name as in Switcher, but I do not like it - it looks like enabled/disabled state of control
            readOnly: false,
            animated: false,
        }

        this.small = additionalClass.includes("small")

        this.onStatePropertyChanged("enabled", value => {
            let images = ImagePathes[this.small ? "small" : "big"]
            if (value) {
                this.getEl().addClass("move on").removeClass("off")
                this.getEl().attr("src", atImgPath(images["on"]));
            } else {
                this.getEl().addClass("move off").removeClass("on")
                this.getEl().attr("src", atImgPath(images["off"]));
            }
        })
    }

    templateHtml() {
        return `<img class="tumblerSwitch <%-additionalClass%>"/>`
    }

    afterRender() {
        this.getEl().click(() => {
            let newValue = !this.state.enabled;
            this.setState({enabled: newValue});
            this.onSwitchCallback(newValue)
        });

        this.renderInitialState();
    }
}


// WEBPACK FOOTER //
// ./web/js/components/TumblerSwitch.js